import { toast } from "react-toastify";
import config from '../../Config/config.json';
import { ChangeUserInfo, LogOut, changeCargos, changeLoations, changeModal } from "../../Redux/Actions/index.js";
import { store } from "../../Redux/Store/index.js";
import { UserRequests } from "./request.ts";
import i18n from "../../Config/i18n.js";

/**
 * Classe para gerenciamento da página de perfil
 */
export class UserServices {
    constructor() {
        this.UserRequests = new UserRequests();
    }

    // Envia o email com requisição para confirmação de email
    async sendEmailConfirmation(){
        try {
            const response = await this.UserRequests.ConfirmEmail();
            toast(response.message, {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return;
        }
    }

    // Resetar verificação de 2 estapas (2-factor authentication)
    async enable2faReset(id){
        try {
            const response = await this.UserRequests.Reset2FactorAuth(id);
            toast(response.message, {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return;
        }
    }

    // Enviar token para confirma email
    async sendEmailToken(Token){
        try {
            const response = await this.UserRequests.SendToken(Token);
            toast(response.message, {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return;
        }
    }

    // Busca qrcode de autenticação
    async getCode(){
        try {
            const response = await this.UserRequests.Getqrcode();
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // Envia código de autenticação de dois fatores
    async sendCode(code, changeState){
        try {
            const response = await this.UserRequests.sendAuthCode(code);
            toast(response.message, {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            store.dispatch(changeModal(null));
            changeState(true);
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // Enviar código de recuperação para autenticação de dois fatores
    async sendVerifyCode(code, changeState, getNewCode){
        try {
            const response = await this.UserRequests.sendRecoveryCode(code);
            toast(response.message, {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            store.dispatch(changeModal(null));
            changeState(false);
            getNewCode();
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // Busca dados do usuário
    async getUser(id){
        try {
            const response = await this.UserRequests.GetUser(id);
            return response.data;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // Busca alocações que o usuário pode ver
    async getLocations(){
        try {
            const response = await this.UserRequests.getlocations();
            this.locations = response;
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // Muda o tipo de alocações sendo exibido
    ChangeLocationType(type, field){
        try {
            store.dispatch(changeLoations(this.locations[type]));
            field.value = '';
            field.focus();
        } catch (error) {
            
        }
    }

    // Envia o usuário para ser editado
    async editUser (Id, user){
        try {
            const response = await this.UserRequests.editUser(Id, user);
            if(Id === store.getState().userReducer.user.id){
                let newuser = store.getState().userReducer;
                newuser = {
                    ...newuser,
                    user : {
                        ...newuser.user,
                        usuario : response.username,
                        foto : response.photo_url,
                        nome : response.name,
                        id : response.id,
                        lang : response.lang
                    }
                };
                response.lang && i18n.changeLanguage(response.lang);   
                store.dispatch(ChangeUserInfo(newuser));
            }
            toast(i18n.t("message.user-service.edit-user"), {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }
  
    // Envia as unidades para ser editadas
    async editMeasurementUnits(id, units){
        try {
            const response = await this.UserRequests.editMeasurementUnits(id, units);
            toast(i18n.t("message.user-service.edit-units"), {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // Envia a foto do usuário para ser editado
    async editUserImage (Id, imageFile){
        try {
            const response = await this.UserRequests.editUserImage(Id, {
                'hidden_file_image': imageFile,
            });
            toast(i18n.t("message.user-service.edit-user"), {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // Deleta a foto do usuário
    async deleteUserImage(id){
        try {
            const response = await this.UserRequests.deleteUserImage(id);
            toast(response.message, {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
        }
    }

    // Oculta a imagem do usuário
    async hideUserImage(id, hideFlag){
        try {
            const response = await this.UserRequests.hideUserImage(id, hideFlag);
            toast(response.message, {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
        }
    }

    // Enviar requisição de troca de senha
    async ChangePassword (oldpassword, newpassword, newpasswordconfirm, isValid){
        if(!isValid){return}
        try {
            if(newpassword !== newpasswordconfirm){
                toast(i18n.t("message.user-service.change-password"), {
                    position: "top-center",
                    type: 'info',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    theme: config.theme,
                });
                return;
            }
            const response = await this.UserRequests.ChangePassword({
                'oldPassword': oldpassword,
                'newPassword': newpassword,
            });
            toast(response.message, {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    async getAllUser(page, search, roles, allocations){
        try {
            const response = await this.UserRequests.getAllUser(page, search, roles, allocations);
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return [];
        }
    }

    // Cria um novo usuário
    async SaveUser (user){
        try {
            const response = await this.UserRequests.CreateUser(user);
            toast(i18n.t("message.user-service.save-user"), {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // Cria um novo usuário e envia senha por email
    async CreateNewUser (user){
        try {
            const response = await this.UserRequests.CreateUser(user);
            toast(i18n.t("message.user-service.response-create-new-user"), {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    async getAuthorizedAllocations(){
        try {
            const response = await this.UserRequests.getAuthorizedAllocations();
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    async getAuthorizedCargos(){
        try {
            const response = await this.UserRequests.getAuthorizedCargos();
            store.dispatch(changeCargos(JSON.parse(JSON.stringify(response.authorized_cargos))));
            return JSON.parse(JSON.stringify(response.authorized_cargos));
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    async deleteUser(id, navigate){
        try {
            const response = await this.UserRequests.deleteUser(id);
            toast(response.message, {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            navigate('/adm/funcionarios');
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
        }
    }

    async sendPhoneCode(){
        try {
            const response = await this.UserRequests.sendPhoneCode();
            toast(response.message, {
                position: "top-center",
                type: 'success',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
        }
    }

    async sendWhatsappCode(){
        try {
            const response = await this.UserRequests.sendWhatsappCode();
            toast(response.message, {
                position: "top-center",
                type: 'success',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
        }
    }

    async sendWhatsappCodeConfirm(code){
        try {
            const response = await this.UserRequests.sendWhatsappCodeConfirm(code);
            store.dispatch(changeModal(''));
            toast(response.message, {
                position: "top-center",
                type: 'success',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
        }
    }

    async sendPhoneCodeConfirm(code){
        try {
            const response = await this.UserRequests.sendPhoneCodeConfirm(code);
            store.dispatch(changeModal(''));
            toast(response.message, {
                position: "top-center",
                type: 'success',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
        }
    }

    // busca inscrições do usuário
    async getEquipamentsSubscribes(){
        try {
            const equipamentosList = await this.UserRequests.getUserSubscribes();
            return equipamentosList;
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return [];
        }
    }

    // busca as variáveis do equipamento
    async GetVariables (equipament){
        try {
            let variaveis = this.UserRequests.GetVariables(equipament);
            return variaveis;
        } catch (error) {
            console.log(error);
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // busca as permissões de equipamentos
    async GetPermissions (equipament){
        try {
            let permissions = await this.UserRequests.GetPermissions(equipament);
            return permissions;
        } catch (error) {
            console.log(error);
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }


    // se inscreve no equipamento
    async subscribe (equipament, variaveis, initialTime, finalTime, subscribeType){
        try {
            const body = {
                "id_equipment": equipament,
                "alerts": variaveis,
                "minimal_interval_rate": initialTime.interval,
                "starter_hour": initialTime.hour+":"+initialTime.minute+":"+initialTime.second,
                "end_hour": finalTime.hour+":"+finalTime.minute+":"+finalTime.second,
                "sms": subscribeType.sms,
                "email": subscribeType.email,
                "whatsapp": subscribeType.whatsapp,
            }
            const response = await this.UserRequests.subscribe(body)
            toast(response.message, {
                position: "top-center",
                type: 'success',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            return true;
        } catch (error) {
            console.log(error);
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // cancela inscrição
    async unsubscribe (user, equipament){
        try {
            const response = await this.UserRequests.unsubscribe(equipament)
            toast(response.message, {
                position: "top-center",
                type: 'success',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            return true;
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // concede permissão para o usuário enviar comandos para o equipamento
    async permission(id, equipament){
        try {
            const response = await this.UserRequests.permission(id, equipament);
            toast(i18n.t("message.allocation-service.response-add-equipament-to-allocation"), {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    async unpermission (userId, equipament){
        try {
            const response = await this.UserRequests.unpermission(userId, equipament)
            toast(response.message, {
                position: "top-center",
                type: 'success',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            return true;
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    async getCities(){
        try {
            const cities = await this.UserRequests.RequestCities();
            return cities.authorized_cities;
        } catch (error) {
            console.log(error);
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return [];
        }
    }

    // encerra sessão do dispositivo
    async invalidateToken (id){
        try {
            const response = await this.UserRequests.RequestDeviceLogout(id)
            toast(response.message, {
                position: "top-center",
                type: 'success',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            return true;
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

}